module.exports = __webpack_public_path__ + "img/zmenit.5acb6b11.svg";